export default "__VITE_ASSET__DkKrHaOR__"